import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../api';

import { parseError } from '../utils/error-handler';
import { isValidLocationId } from '../utils/locationId';

export const useQueryActivePayments = (locationId?: string) => {
  const apiClient = useApiClient();
  return useQuery({
    enabled: isValidLocationId(locationId),
    queryFn: async () => {
      return apiClient.ListActivePaymentController.listActivePaymentsV2({ locationId: locationId! }, {}).catch(
        parseError
      );
    },
    queryKey: ['active-payments', locationId],
    staleTime: 5 * 60 * 1000, // 5 min
  });
};
